import classnames from "classnames";
import isNumber from "lodash/isNumber";
import {useState} from "react";
import {FaCaretDown, FaCaretRight} from "react-icons/fa6";

import {getPercentageClass} from "@/lib/cssUtils.ts";
import {durationSecFn, percentage} from "@/lib/format.tsx";
import {SLAReport, SLAReportViewGroup} from "@/lib/queries/reports.ts";
import {formatResponseTime} from "@/pages/checks/analysis/overview/utils.ts";
import {SLAReportServiceTableRow} from "@/pages/reports/sla/details/SLAReportServiceTableRow.tsx";
import {KEY_TAB} from "@/wcag.ts";

interface SLAReportServiceTableRowGroupProps {
  group: SLAReportViewGroup;
  report: SLAReport;
}

export const SLAReportServiceTableRowGroup = ({group, report}: SLAReportServiceTableRowGroupProps) => {
  // use state to toggle collapse so we can use caret icons
  const [collapse, setCollapse] = useState<boolean>(true);
  const hasServices = group.uptime.services.length > 0;
  return (
    <>
      <tr>
        <td
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key !== KEY_TAB) {
              setCollapse(!collapse);
            }
          }}
          className="cursor-pointer"
          onClick={() => setCollapse(!collapse)}
        >
          {hasServices && collapse && <FaCaretRight />}
          {hasServices && !collapse && <FaCaretDown />}
          <span className="ms-1 text-primary">{group.group.name}</span>
        </td>
        {report.show_uptime_sla && <td className="text-center">{percentage(group.uptime_totals.uptime_sla)}</td>}
        <td
          className={classnames(
            getPercentageClass(group.uptime_totals.uptime_pct, group.uptime_totals.uptime_sla),
            "text-center"
          )}
        >
          {isNumber(group.uptime_totals.uptime_pct) ? percentage(group.uptime_totals.uptime_pct) : "-"}
        </td>
        <td className="text-center">{group.uptime_totals.outages}</td>
        <td
          className={classnames(
            {
              [getPercentageClass(group.uptime_totals.uptime_pct, group.uptime_totals.uptime_sla)]:
                group.uptime_totals.downtime_secs > 0,
            },
            "text-center"
          )}
        >
          {durationSecFn(group.uptime_totals.downtime_secs) || "0h 0m 0s"}
        </td>
        <td className="text-center">{formatResponseTime(group.uptime_totals.response_time_avg, "-")}</td>
        <td />
      </tr>
      {!collapse &&
        group.uptime.services.map((item) => <SLAReportServiceTableRow report={report} item={item} isInner />)}
    </>
  );
};
